export default __webpack_public_path__ + "static/media/070_boost.hevc.d0a73ac6.mp4";